import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { LanguageProvider } from "@/i18n";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import SpeciesDetail from "@/pages/SpeciesDetail";

function App() {
  return (
    <div className="App grain-overlay bg-brand-bone">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <SmoothScroll>
                  <Home />
                </SmoothScroll>
              }
            />
            <Route path="/species/:slug" element={<SpeciesDetail />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <WhatsAppButton />
        </BrowserRouter>
      </LanguageProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0B192C",
            color: "#F7F5F0",
            border: "1px solid #8B5A2B",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
